<template>
  <div class="close-success">
    <CommonBanner :tagline="paymentTitle" :title="paymentAmount" />
    <ProductButton @click="$router.replace('/bank/red/paymentcalendar')">
      <template #title>
        <span class="text-primary">{{ $t`Календарь счетов` }}</span>
      </template>
      <template #tail>
        <div class="i-arrow"></div>
      </template>
    </ProductButton>
    <CommonButton spaced @click="$router.replace('/bank/red')">
      {{ $t`Вернуться в Kaspi Red` }}
    </CommonButton>
  </div>
</template>

<script>
import { getDateText } from "@/utils/date";
import CommonBanner from "@/components/shared/banner/CommonBanner.vue";
import CommonButton from "@/components/shared/button/CommonButton.vue";
import ProductButton from "@/components/shared/button/ProductButton.vue";
import dayjs from "dayjs";

export default {
  components: {
    CommonBanner,
    CommonButton,
    ProductButton,
  },
  computed: {
    paymentAmount() {
      return this.$currencyFormatter(this.$route.query.amount);
    },
    paymentTitle() {
      const date = this.$route.query.date;
      if (!dayjs(date, "YYYY-MM-DD").isValid()) {
        return this.$t`Счет Kaspi Red оплачен`;
      }
      return this.$l10nformat(this.$t`Счет Kaspi Red </br> до #DATE# оплачен`, {
        DATE: getDateText(date, "dative"),
      });
    },
  },
  mounted() {
    this.$logAnalyticEvent("mybank_red_bill_repayment_complete", {
      amount: this.$route.query.amount,
      page_path: "",
      started_from: "",
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.text-primary {
  color: $colorCerulean;
}
</style>
